import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RegisterPrompt = () => {
  return (
    <div className="mt-6 md:mt-8 lg:mt-10 p-4 md:p-6 bg-card/30 border-2 border-secondary/30 rounded-sm">
      <div className="text-center space-y-3 md:space-y-4">
        <div className="flex items-center justify-center gap-2">
          <Icon name="UserPlus" size={20} color="var(--color-secondary)" />
          <p className="text-sm md:text-base font-caption text-foreground">
            New to CyberOddEven?
          </p>
        </div>
        
        <p className="text-xs md:text-sm font-body text-muted-foreground max-w-sm mx-auto">
          Join the psychological gaming arena and challenge AI opponents with unique personalities
        </p>

        <Link
          to="/register"
          className="inline-flex items-center gap-2 px-6 md:px-8 py-2 md:py-3 bg-secondary/20 text-secondary border-2 border-secondary rounded-sm font-caption text-sm md:text-base tracking-wide hover:bg-secondary/30 hover:shadow-glow-magenta-md transition-all duration-base touch-target"
        >
          <span>CREATE ACCOUNT</span>
          <Icon name="ArrowRight" size={18} />
        </Link>
      </div>
    </div>
  );
};

export default RegisterPrompt;